import React from 'react';
import { TableSummaryRow } from '@devexpress/dx-react-grid-material-ui';
import { Typography } from '@mui/material';

export function ScheduleGroupGridTableSummaryRowCell({ value }: TableSummaryRow.ItemProps) {
  return <Typography>{value}</Typography>;
}
